export const PILLOW_TALK_SUPPORT_LOCALES = ['en-US', 'es-LA', 'es-ES', 'fr-CA', 'fr-FR', 'pt-BR'] as const;

export const LIVE_PERSON_ENGLISH_ONLY_SUPPORT_LOCALES = [
  'fi-FI',
  'hu-HU',
  'he-IL',
  'da-DK',
  'el-GR',
  'nb-NO',
  'pt-PT',
  'uk-UA',
] as const;
